module.exports = __webpack_public_path__ + "assets/img/1131587020882_.pic_hd.09e1b9aa.jpg";